const dev = {
  API_ENDPOINT_URL:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api",
  QURAN_API_URL: process.env.REACT_APP_QURAN_API_URL || "http://localhost:3077",
};

const prod = {
  API_ENDPOINT_URL:
    process.env.REACT_APP_API_BASE_URL || "https://backend.prefacetoislam.com/api",
  QURAN_API_URL:
    process.env.REACT_APP_QURAN_API_URL || "https://quranbackend.prefacetoislam.com",
};

const test = {
  API_ENDPOINT_URL: "/api",
  QURAN_API_URL:
    process.env.REACT_APP_QURAN_API_URL || "https://quranbackend.prefacetoislam.com",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
